<script lang="ts">
  import { locale } from 'svelte-i18n';

  const availableLocales = [
    { code: 'en', label: 'English' },
    { code: 'de', label: 'Deutsch' },
    { code: 'fr', label: 'Français' },
    { code: 'it', label: 'Italiano' }
  ];
</script>

<select
  bind:value={$locale}
  id="language"
  class="form-select focus:ring-opacity-0 mt-1 ml-auto block rounded-md border-gray-300 text-sm shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200"
>
  {#each availableLocales as l (l.code)}
    <option value={l.code}>{l.label}</option>
  {/each}
</select>
